import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet"
import React, { useState } from "react"
import { useQuery } from "@tanstack/react-query"
import { client } from "@/hooks/useClient"
import { endpoints } from "@/config/endpoints.config"
import { Scenario } from "@/gen"
import { Label } from "@/components/ui/label"

interface ExecutionNodeInputOutputProps {
  children: React.ReactNode
  scenario: Scenario
  execution: any
  nodeId: number
}

export function ExecutionNodeInputOutput(props: ExecutionNodeInputOutputProps) {
  const [open, setOpen] = useState(false)

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>{props.children}</SheetTrigger>
      <SheetContent className="md:w-xl md:max-w-screen">
        <SheetHeader>
          <SheetTitle>Node #{props.nodeId}</SheetTitle>
          <SheetDescription></SheetDescription>
        </SheetHeader>
        {open && <ExecutionNodeInputOutputContent {...props} />}
      </SheetContent>
    </Sheet>
  )
}

function ExecutionNodeInputOutputContent(props: ExecutionNodeInputOutputProps) {
  const queryResult = useQuery({
    queryKey: ["scenarios-execution-node-input-output", props.scenario.id, props.execution.id, props.nodeId],
    queryFn: async () => {
      return client
        .get<any>(`${endpoints.SCENARIOS}/${props.scenario.id}/executions/${props.execution.id}/nodes/${props.nodeId}`)
        .then((res) => res.data)
    },
  })

  return (
    <div className="px-4 [&_pre]:overflow-x-auto">
      <Label>Input</Label>
      <br />
      <div className="bg-ground rounded-2xl p-4 flex flex-col gap-1 text-xs mb-1 !text-left !w-full hover:bg-ground-active">
        <pre>{JSON.stringify(queryResult.data?.input || null, null, 2)}</pre>
      </div>
      <br />
      <Label>Properties</Label>
      <br />
      <div className="bg-ground rounded-2xl p-4 flex flex-col gap-1 text-xs mb-1 !text-left !w-full hover:bg-ground-active">
        <pre>{JSON.stringify(queryResult.data?.properties || null, null, 2)}</pre>
      </div>
      <br />
      <Label>Output</Label>
      <br />
      <div className="bg-ground rounded-2xl p-4 flex flex-col gap-1 text-xs mb-1 !text-left !w-full hover:bg-ground-active">
        <pre>{JSON.stringify(queryResult.data?.output || null, null, 2)}</pre>
      </div>
      <br />
      <Label>Logs</Label>
      <br />
      {queryResult.data?.logs?.length > 0 && (
        <div className="bg-ground rounded-2xl p-4 flex flex-col gap-1 text-xs mb-1 !text-left !w-full hover:bg-ground-active">
          <pre>{queryResult.data?.logs?.join("\n")}</pre>
        </div>
      )}
      <br />
      <br />
      <Label>Errors</Label>
      <br />
      <div className="bg-ground rounded-2xl p-4 flex flex-col gap-1 text-xs mb-1 !text-left !w-full hover:bg-ground-active">
        <pre>{JSON.stringify(queryResult.data?.error || null, null, 2)}</pre>
      </div>
      <br />
      <br />
    </div>
  )
}
